const { registerBlockType } = wp.blocks;
const { PanelBody, RangeControl, SelectControl, ToggleControl } = wp.components;
const { InspectorControls, RichText, URLInputButton } = wp.blockEditor;
const { useEffect, useState } = wp.element;
const { apiFetch } = wp;
const { useSelect } = wp.data;
const { __ } = wp.i18n;

registerBlockType('pg/more-news', {
  title: 'PG More Posts',
  icon: 'megaphone',
  category: 'widgets',
  attributes: {
    headingText: {
      type: 'string',
      default: 'More episodes',
    },
    seeMoreUrl: {
      type: 'string',
      default: '',
    },
    seeMoreText: {
      type: 'string',
      default: 'See more',
    },
    numberOfPosts: {
      type: 'number',
      default: 3,
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-left-top',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    showExcerpt: {
      type: 'boolean',
      default: false,
    },
  },
  edit: ({ attributes, setAttributes, isSelected }) => {
    const {
      numberOfPosts,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      showExcerpt,
    } = attributes;
    const [latestPosts, setLatestPosts] = useState([]);
    let currentDelay = 300;

    const currentPostId = useSelect(
      (select) => select('core/editor').getCurrentPostId(),
      []
    );
    const currentPostCategories = useSelect(
      (select) => select('core/editor').getEditedPostAttribute('categories'),
      [currentPostId]
    );

    useEffect(() => {
      if (!latestPosts || !latestPosts.length) {
        return;
      }
    }, [latestPosts]);

    const incrementDelay = () => {
      currentDelay += 200;
      return currentDelay;
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString('default', { month: 'long', year: 'numeric' });
    };

    useEffect(() => {
      if (currentPostCategories && currentPostCategories.length > 0) {
        const categories = currentPostCategories.join(',');
        apiFetch({
          path: `/wp/v2/posts?categories=${categories}&exclude=${currentPostId}&per_page=${numberOfPosts}&_embed`,
        })
          .then((posts) => {
            setLatestPosts(posts);
          })
          .catch(() => {
            setLatestPosts([]);
          });
      }
    }, [numberOfPosts, currentPostCategories, currentPostId]);

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const onChangeCornerPositionClass = (newClass) => {
      setAttributes({ cornerPositionClass: newClass });
    };

    const onChangeCornerBackgroundClass = (newClass) => {
      setAttributes({ cornerBackgroundClass: newClass });
    };

    return (
      <div>
        {isSelected && (
          <InspectorControls>
            <PanelBody title="Settings">
              <RangeControl
                label="Number of Insights"
                value={attributes.numberOfPosts}
                onChange={(newCount) =>
                  setAttributes({ numberOfPosts: newCount })
                }
                min={1}
                max={10}
              />
              <SelectControl
                label={__('Section Class')}
                value={sectionClass}
                options={[
                  { label: 'Light Primary', value: 'section-light-primary' },
                  { label: 'Dark Primary', value: 'section-dark-primary' },
                  {
                    label: 'Light Secondary',
                    value: 'section-light-secondary',
                  },
                  { label: 'Dark Secondary', value: 'section-dark-secondary' },
                ]}
                onChange={onChangeSectionClass}
              />
              <SelectControl
                label={__('Corner Position')}
                value={cornerPositionClass}
                options={[
                  { label: 'Left-Top', value: 'corner-left-top' },
                  { label: 'Left-Bottom', value: 'corner-left-bottom' },
                  { label: 'Right-Top', value: 'corner-right-top' },
                  { label: 'Right-Bottom', value: 'corner-right-bottom' },
                ]}
                onChange={onChangeCornerPositionClass}
              />
              <SelectControl
                label={__('Corner Background')}
                value={cornerBackgroundClass}
                options={[
                  {
                    label: 'On Light Primary',
                    value: 'corner-on-light-primary',
                  },
                  {
                    label: 'On Light Secondary',
                    value: 'corner-on-light-secondary',
                  },
                  { label: 'On Dark Primary', value: 'corner-on-dark-primary' },
                  {
                    label: 'On Dark Secondary',
                    value: 'corner-on-dark-secondary',
                  },
                ]}
                onChange={onChangeCornerBackgroundClass}
              />
              <ToggleControl
                label={__('Show Excerpt')}
                checked={showExcerpt}
                onChange={(value) => setAttributes({ showExcerpt: value })}
              />
            </PanelBody>
          </InspectorControls>
        )}
        <section className={sectionClass}>
          <div
            className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
          ></div>
          <div className="insights-wrapper">
            <div className="top">
              <RichText
                tagName="h2"
                value={attributes.headingText}
                onChange={(newText) => setAttributes({ headingText: newText })}
                placeholder="Enter heading..."
              />
              <a
                href={'#'}
                className={'btn btn-dark btn-outline'}
                title={attributes.seeMoreUrl}
              >
                <RichText
                  tagName="span"
                  value={attributes.seeMoreText}
                  onChange={(newSeeMoreText) =>
                    setAttributes({ seeMoreText: newSeeMoreText })
                  }
                />
                <URLInputButton
                  url={attributes.seeMoreUrl}
                  onChange={(newUrl) => setAttributes({ seeMoreUrl: newUrl })}
                />
              </a>
            </div>
            <div className="columns-wrapper">
              {latestPosts.length ? (
                latestPosts.map((post) => {
                  const featuredImage =
                    post._embedded &&
                    post._embedded['wp:featuredmedia'] &&
                    post._embedded['wp:featuredmedia'][0] &&
                    post._embedded['wp:featuredmedia'][0].source_url;

                  const altText =
                    post._embedded &&
                    post._embedded['wp:featuredmedia'] &&
                    post._embedded['wp:featuredmedia'][0] &&
                    post._embedded['wp:featuredmedia'][0].alt_text;

                  const postAltText = altText || post.title.rendered; // Use alt text or fallback to post title

                  const postDate = formatDate(post.date);
                  const categories =
                    post._embedded &&
                    post._embedded['wp:term'] &&
                    post._embedded['wp:term'][0];
                  let categoryDisplay = '';

                  if (categories && categories.length > 0) {
                    const categoryName = categories[0].name;
                    categoryDisplay =
                      categoryName.toLowerCase() !== 'uncategorized'
                        ? `${categoryName} | `
                        : '';
                  }

                  const delayForThisItem = incrementDelay();

                  return (
                    <div key={post.id} className="column">
                      <div className={'image'}>
                        <img src={featuredImage} alt={postAltText} />{' '}
                        {/* Use postAltText */}
                        <p>
                          <span>New</span>
                          <a
                            href={post.link}
                            className="btn btn-light btn-outline btn-icon btn-small"
                          ></a>
                        </p>
                      </div>
                      <h3
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      />
                      {showExcerpt && post.excerpt && (
                        <p className="description">{post.excerpt.rendered}</p>
                      )}
                    </div>
                  );
                })
              ) : (
                <p>Loading latest insights...</p>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  },
  save: () => null,
});
